import React from 'react'
import { Divider, Stack } from '@mui/material'

import Header from './Header'
import Content from './Content'
import { FragmentType, graphql, useFragment } from '@/generated/gql'

const canteenCartTopUpUserDataFragment = graphql(`
  fragment CanteenCartTopUp_UserDataFragment on User {
    ...CanteenCartTopUpHeader_UserDataFragment
    ...CanteenCartTopUpContent_UserDataFragment
  }
`)

type Props = {
  onBackClicked: () => void
  onCheckoutClicked: (bundle: number) => void
  loading: boolean
  cartTotal: number
  userData: FragmentType<typeof canteenCartTopUpUserDataFragment>
  currency: string
  availableSubsidy: number
}

const TopUp: React.FC<Props> = ({
  userData: userDataProp,
  onBackClicked,
  onCheckoutClicked,
  cartTotal,
  loading,
  currency,
  availableSubsidy,
}) => {
  const userData = useFragment(canteenCartTopUpUserDataFragment, userDataProp)
  return (
    <Stack spacing={3} direction="column" height="100vh" width="100%">
      <Stack direction="column">
        <Header
          userData={userData}
          availableSubsidy={availableSubsidy}
          onBackClicked={onBackClicked}
        />
        <Divider />
      </Stack>
      <Content
        currency={currency}
        userData={userData}
        availableSubsidy={availableSubsidy}
        onCheckoutClicked={onCheckoutClicked}
        cartTotal={cartTotal}
        loading={loading}
      />
    </Stack>
  )
}

export default TopUp
